

































import { Vue, Prop, Component } from 'vue-property-decorator';
import EditIcon from '@/components/icons/EditIcon.vue';
import ArrowUpIcon from '@/components/icons/ArrowUpIcon.vue';
import ArrowDownIcon from '@/components/icons/ArrowDownIcon.vue';
import WarningIcon from '@/components/icons/WarningIcon.vue';
import InfoTooltip from '@/components/common/InfoTooltip.vue';

@Component({
  components: {
    EditIcon,
    ArrowDownIcon,
    ArrowUpIcon,
    InfoTooltip,
    WarningIcon
  }
})
export default class OrganisationFormSection extends Vue {
  @Prop(String)
  heading!: string;
  @Prop(String)
  tooltip!: string;
  @Prop(Boolean)
  alwaysOpen!: boolean;
  @Prop(Boolean)
  invalid!: boolean;
  @Prop(Boolean)
  disabled!: boolean;
  @Prop({ type: String, default: '' })
  placeholder!: string;
  @Prop(Boolean)
  canEdit!: boolean;

  expanded = false;

  toggleEdit() {
    this.expanded = this.disabled;
    this.$emit('edit', !this.disabled);
  }

  toggleExpand() {
    if (!this.disabled) {
      return;
    }
    this.expanded = !this.expanded;
  }

  get isExpandable() {
    return !this.alwaysOpen && !this.invalid && this.disabled;
  }

  get isExpanded() {
    return this.expanded || this.alwaysOpen || this.invalid || !this.disabled;
  }
}
